import { render, staticRenderFns } from "./PaymentSystems.vue?vue&type=template&id=4e340734&"
import script from "./PaymentSystems.vue?vue&type=script&lang=js&"
export * from "./PaymentSystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports